<!--
/**

*********	*******		*******		********	**			 **		  ***	 	*******		**	 **
**			**	 **		**	 **		**			 **	   *    **		 ** **   	**	 **		**** **
*******		**	 **		*******		********	  **  ***  **		*******  	*******		** ****
**			**	 **		** *		**			   **** ****	   **	  ** 	** *		**	***
**			*******		**  **		********		**   **		  **	   **	**  **		**	 **

* ForeWarn  Licensing and / or usage Terms and Conditions  *******
* ForeWarn. The NextGen Insights Solution Platform
* Copyright © 2021 COMPEGENCE. All Rights Reserved
* ForeWarn is a product of COMPEGENCE.
* To be used only with a valid license from COMPEGENCE
* www.compegence.com  info@compegence.com
**/
-->

<template>
  <div id="app">
    <app-header v-if="shouldShowHeader"></app-header>
    <div class="">
      <app-menu v-if="shouldShowHeader &&
                $store.state.showSideMenu &&
                !$store.state.user.enforcePasswordReset
                ">
      </app-menu>
      <div class="main-content-area flex-grow-1">
        <banner v-if="shouldShowHeader && !$store.state.user.enforcePasswordReset" v-show="$store.state.showBanner"></banner>

        <div class="router-container">
          <router-view/>
        <transition name="fade">
        <div v-if="$store.state.apiCount > 0" class="inner-loader-overlay">
          <svg version="1.1" width="320" height="320" viewBox="0 0 320 320" fill="none" stroke="#000" stroke-linecap="round"
               xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
              <path id="r1">
                <animate id="p1" attributeName="d" values="m160,160l0,0 0,0;m130,110l30,-17 30,17;m130,60l30,-17 30,17;m160,20l0,0 0,0" dur="6s" repeatCount="indefinite"/>
                <animate attributeName="stroke-width" values="0;4;4;4;0" dur="6s" repeatCount="indefinite" begin="p1.begin"/>
              </path>
              <path id="r2">
                <animate attributeName="d" values="m160,160l0,0 0,0;m130,110l30,-17 30,17;m130,60l30,-17 30,17;m160,20l0,0 0,0" dur="6s" repeatCount="indefinite" begin="p1.begin+1s"/>
                <animate attributeName="stroke-width" values="0;4;4;4;0" dur="6s" repeatCount="indefinite" begin="p1.begin+1s"/>
              </path>
              <path id="r3">
                <animate attributeName="d" values="m160,160l0,0 0,0;m130,110l30,-17 30,17;m130,60l30,-17 30,17;m160,20l0,0 0,0" dur="6s" repeatCount="indefinite" begin="p1.begin+2s"/>
                <animate attributeName="stroke-width" values="0;4;4;4;0" dur="6s" repeatCount="indefinite" begin="p1.begin+2s"/>
              </path>
              <path id="r4">
                <animate id="p1" attributeName="d" values="m160,160l0,0 0,0;m130,110l30,-17 30,17;m130,60l30,-17 30,17;m160,20l0,0 0,0" dur="6s" repeatCount="indefinite" begin="p1.begin+3s"/>
                <animate attributeName="stroke-width" values="0;4;4;4;0" dur="6s" repeatCount="indefinite" begin="p1.begin+3s"/>
              </path>
              <path id="r5">
                <animate attributeName="d" values="m160,160l0,0 0,0;m130,110l30,-17 30,17;m130,60l30,-17 30,17;m160,20l0,0 0,0" dur="6s" repeatCount="indefinite" begin="p1.begin+4s"/>
                <animate attributeName="stroke-width" values="0;4;4;4;0" dur="6s" repeatCount="indefinite" begin="p1.begin+4s"/>
              </path>
              <path id="r6">
                <animate attributeName="d" values="m160,160l0,0 0,0;m130,110l30,-17 30,17;m130,60l30,-17 30,17;m160,20l0,0 0,0" dur="6s" repeatCount="indefinite" begin="p1.begin+5s"/>
                <animate attributeName="stroke-width" values="0;4;4;4;0" dur="6s" repeatCount="indefinite" begin="p1.begin+5s"/>
              </path>
            </defs>
            <use xlink:href="#r1"/>
            <use xlink:href="#r1" transform="rotate(60 160 160)"/>
            <use xlink:href="#r1" transform="rotate(120 160 160)"/>
            <use xlink:href="#r1" transform="rotate(180 160 160)"/>
            <use xlink:href="#r1" transform="rotate(240 160 160)"/>
            <use xlink:href="#r1" transform="rotate(300 160 160)"/>
            <use xlink:href="#r2" transform="rotate(30 160 160)"/>
            <use xlink:href="#r2" transform="rotate(90 160 160)"/>
            <use xlink:href="#r2" transform="rotate(150 160 160)"/>
            <use xlink:href="#r2" transform="rotate(210 160 160)"/>
            <use xlink:href="#r2" transform="rotate(270 160 160)"/>
            <use xlink:href="#r2" transform="rotate(330 160 160)"/>
            <use xlink:href="#r3"/>
            <use xlink:href="#r3" transform="rotate(60 160 160)"/>
            <use xlink:href="#r3" transform="rotate(120 160 160)"/>
            <use xlink:href="#r3" transform="rotate(180 160 160)"/>
            <use xlink:href="#r3" transform="rotate(240 160 160)"/>
            <use xlink:href="#r3" transform="rotate(300 160 160)"/>
            <use xlink:href="#r4" transform="rotate(30 160 160)"/>
            <use xlink:href="#r4" transform="rotate(90 160 160)"/>
            <use xlink:href="#r4" transform="rotate(150 160 160)"/>
            <use xlink:href="#r4" transform="rotate(210 160 160)"/>
            <use xlink:href="#r4" transform="rotate(270 160 160)"/>
            <use xlink:href="#r4" transform="rotate(330 160 160)"/>
            <use xlink:href="#r5"/>
            <use xlink:href="#r5" transform="rotate(60 160 160)"/>
            <use xlink:href="#r5" transform="rotate(120 160 160)"/>
            <use xlink:href="#r5" transform="rotate(180 160 160)"/>
            <use xlink:href="#r5" transform="rotate(240 160 160)"/>
            <use xlink:href="#r5" transform="rotate(300 160 160)"/>
            <use xlink:href="#r6" transform="rotate(30 160 160)"/>
            <use xlink:href="#r6" transform="rotate(90 160 160)"/>
            <use xlink:href="#r6" transform="rotate(150 160 160)"/>
            <use xlink:href="#r6" transform="rotate(210 160 160)"/>
            <use xlink:href="#r6" transform="rotate(270 160 160)"/>
            <use xlink:href="#r6" transform="rotate(330 160 160)"/>
          </svg>
        </div>
        </transition>
          <modal
              v-if="showErrorModal"
              :isVisible="showErrorModal"
              @close="closeErrorModal"
              :title="errorTitle"
          >
          </modal>
      </div>
      </div>
    </div>
  </div>

</template>

<script>
import AppHeader from './components/AppHeader'
import AppMenu from './components/AppMenu'
import Banner from './components/banner-dyn'
import Modal from "@/components/Modal.vue";

export default {
  name: 'App',
  components: {Modal, AppHeader, Banner, AppMenu/*,nandusbanners*/},
  data () {
    return {
      menuPath: {}
    }
  },
  computed: {
    showErrorModal() {
      return this.$store.state.isBackendError;
    },
    errorTitle() {
      const roleMsg = this.$store.state.userRoleRestriction?.errorMessageTemplate;
      const clientMsg = this.$store.state.fwMClient?.[0]?.errorMessageTemplate;

      return roleMsg || clientMsg || "Data Not Found. Please contact data team.";
    },
    shouldShowHeader() {
      const state = this.$store.state;

      // Basic conditions (logged in, state loaded, menu enabled)
      if (!state.isLoggedIn || !state.stateLoaded || !state.isAppMenuAndAppHeaderDisplay) {
        return false;
      }

      // Desktop always shows header
      if (state.deviceType === 'Desktop') {
        return true;
      }

      // Mobile checks
      if (state.deviceType === 'Mobile') {
        const userShowHeader = state.user?.deviceLandingPageConfig?.['nav-header'];
        const roleShowHeader = state.userRoleRestriction?.deviceLandingPageConfig?.['nav-header'];

        // Check if either config explicitly equals "show"
        return userShowHeader === "show" || roleShowHeader === "show";
      }

      return false;
    },

    serverDown () {
      return this.$store.state.serverIsDown
    },
    dataIssue () {
      return this.$store.state.dataIssue
    },
    authRequired () {
      return this.$store.state.authRequired
    },
    roleSwitchConfirmation () {
      return this.$store.state.roleSwitchConfirmation
    }
  },
  watch: {
    // '$route' (to, from) {
    //   // Your logic to handle route changes
    //   console.log(`Mapsd from ${from.path} to ${to.path}`);
    //   this.annotationMessages()
    // },
    serverDown: function (newval) {
      if (newval) {
        /*  this.$bvToast.toast(`Server Is Down`, {
            title: 'App Server Seems to be Down, please contact Technical Support Team',
            autoHideDelay: 5000,
            //  noAutoHide:true,
            appendToast: false,
            noCloseButton: true,
            variant: 'danger'
          })*/
      }
    },
    roleSwitchConfirmation: function (newval) {
      if (newval) {
        this.$bvToast.toast(`Role Switch Confirmation`, {
          title: 'You Have Successfully Switched Role Thank You',
          autoHideDelay: 2000,
          appendToast: false,
          noCloseButton: true,
          variant: 'success'
        })
        this.clearState()
      }
    }
  },
  async created () {
    if (this.$store.state.isLoggedIn) {
      console.log('app', 'load state'); await this.$store.dispatch("loadState")

      let rc = 0
      let j = setInterval(async () => {
        //wait fo the state to be loaded
        if (this.$store.state.stateLoaded) {
          clearInterval(j)
          await this.$store.dispatch('loadAnnotations')
          await this.loadCurrentPath()
          await this.setLoadStateLoop()
        } else {
          console.info(`state is not loaded...${rc++}`)
        }
      }, 500)

    }
    // else {
    //   //if not logged in and already not in login page then go to login page
    //   if (this.$route.path !== '/login'  && this.$route.name !== 'field-simple' && this.$route.name !== 'field-deepdive') {
    //     console.log("app else condition",this.$route)
    //     await this.$router.push('/login')
    //   }
    // }
  },
  methods: {
    closeErrorModal() {
      // Dispatch an action or commit a mutation to update the store
      this.$store.commit('backendError', false);
    },
  annotationMessages(){
    this.$store.dispatch('loadAnnotations');
  },
    setLoadStateLoop(){
      setInterval(async () => {
        await this.$store.dispatch("loadState")
      }, 120*1000) //every 2 min
    },
    clearState () {
      setTimeout(() => {
        this.$store.commit('clearError')
      }, 3000)
    },
    async loadCurrentPath () {
      console.log("loadCurrentPath")
      let currentPath = this.$router.currentRoute.path
      if (currentPath !== '/') {
        let parentMenu = currentPath.split('/')
        console.info('current menu and parent is', currentPath, parentMenu)
        this.menuPath.pId = parentMenu[2]
        this.menuPath.cId = parentMenu[3]
        await this.$store.dispatch('loadMenuPath', this.menuPath)
      } else {
        console.log('currentPath == /')
      }
    }
  }
}
</script>

<style scoped>
/* Ensure the sidebar stays on top of the transparent loader */
app-menu {
  position: relative;
  z-index: 1000; /* Higher than the loader */
  flex-shrink: 0; /* Prevents the menu from being "squeezed" */
}

.main-content-area {
  position: relative; /* Boundary for the loader */
  flex-grow: 1;
  overflow-x: hidden; /* Prevents horizontal scroll issues */
}

.inner-loader-overlay {
  /* Change from 'fixed' to 'absolute' to keep it inside main-content-area */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  /* This ensures it covers the full height even if the page is long */
  min-height: 100%;

  background-color: rgba(255, 255, 255, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99; /* Lower than menu, higher than charts */
  backdrop-filter: blur(1px);
}

/* Fix for the SVG icon to keep it visible on screen while scrolling */
.inner-loader-overlay svg {
  position: sticky;
  top: 50%;
  transform: translateY(-50%);
}


#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  min-width: 100vw;
/*  margin-top: 60px;*/
}

/*#loading {
  width: 100vw !important;
  height: 100vh !important;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

#loading svg {
  width: 25vw !important;
}*/
</style>
